import { IPublicRoutes } from "./interfaces";

const PublicRoutes: IPublicRoutes = {
    orderDetails: "o/:guid"
  };
  
  export { PublicRoutes };